import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import MarketsContext from "context/MarketsContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CreateMandate from "./CreateMandate";
import UserService from "services/UserService";
import axios from "axios";
import { getMarketMembershipFiles } from "services/ConfigServices";
import { mandateStatusDataTab } from "variables/lists/markets";
import { mandates } from "variables/markets";
import moment from "moment";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function useMandateTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const marketadmin = permis.includes("markets_admin");
  const markets_update = permis.includes("markets_update");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMarketMembershipFiles(chartIdGroup, market.id, 'mandate');
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMandates, setSelectedMandates] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );


  const UploadComponent = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        <CreateMandate refetch={refreshTable} onClick={onUpload} />
      </UploadButton>
    </>
  );

  const filteredItems = _.get(results, `files`, []).filter(
    (item) =>
      (item.parameters.docnumber && item.parameters.docnumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.docname && item.parameters.docname.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.legalentity && item.parameters.legalentity.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.representedby && item.parameters.representedby.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.status && mandateStatusDataTab.find((x) => x.id == item.parameters.status) && mandateStatusDataTab.find((x) => x.id == item.parameters.status).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.datebegin && moment(item.parameters.datebegin).isValid() && moment(item.parameters.datebegin).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.dateend && moment(item.parameters.dateend).isValid() && moment(item.parameters.dateend).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.datesignature && moment(item.parameters.datesignature).isValid() && moment(item.parameters.datesignature).format("DD/MM/YYYY").includes(filterText)) ||
      (item.marketmembershipnumber && item.marketmembershipnumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.marketmembershipname && item.marketmembershipname.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedMandates.map((item) => {
      let mandatetoexport = {};
      mandatetoexport[mandates.docnumber] = item.parameters.docnumber;
      mandatetoexport[mandates.docname] = item.parameters.docname;
      mandatetoexport[mandates.marketmembershipnumber] = item.marketmembershipnumber;
      mandatetoexport[mandates.marketmembershipname] = item.marketmembershipname;
      mandatetoexport[mandates.legalentity] = item.parameters.legalentity;
      mandatetoexport[mandates.representedby] = item.parameters.representedby;
      mandatetoexport[mandates.status] = mandateStatusDataTab.find((x) => x.id == item.parameters.status)?.name;
      mandatetoexport[mandates.datebegin] = (item.parameters.datebegin && moment(item.parameters.datebegin).isValid()) ? moment(item.parameters.datebegin).format("DD/MM/YYYY") : "";
      mandatetoexport[mandates.dateend] = (item.parameters.dateend && moment(item.parameters.dateend).isValid()) ? moment(item.parameters.dateend).format("DD/MM/YYYY") : "";
      mandatetoexport[mandates.datesignature] = (item.parameters.datesignature && moment(item.parameters.datesignature).isValid()) ? moment(item.parameters.datesignature).format("DD/MM/YYYY") : "";
      return mandatetoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {markets_update && (
          <UploadButton type="button" onClick={handleClear}>
            <CreateMandate refetch={refreshTable} onClick={handleClear} />
          </UploadButton>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedMandates || selectedMandates.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedMandates]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedMandates
  };
}
